import { useNavigate } from "react-router-dom";
import { FlowNav } from "../components/FlowNav";
import { useSession } from "../state/SessionProvider";

/**
 * Prototype privacy disclosure (Item 19).
 * Plain-language description of current behavior — legal/SME/survivor review pending (Item 22).
 * Nested informational page: Back + Home per navigation contract (no breadcrumbs).
 */
export function PrivacyPage() {
  const navigate = useNavigate();
  const { translate } = useSession();

  function goHome() {
    navigate("/");
  }

  return (
    <section className="stack privacy-page" aria-labelledby="privacy-heading">
      <FlowNav onBack={goHome} onHome={goHome} />

      <h1 id="privacy-heading" tabIndex={-1}>
        {translate("page.privacy.title")}
      </h1>
      <p>{translate("page.privacy.intro")}</p>

      <h2>{translate("page.privacy.does_not.heading")}</h2>
      <ul>
        <li>{translate("page.privacy.does_not.account")}</li>
        <li>{translate("page.privacy.does_not.name")}</li>
        <li>{translate("page.privacy.does_not.email")}</li>
        <li>{translate("page.privacy.does_not.phone")}</li>
        <li>{translate("page.privacy.does_not.gps")}</li>
        <li>{translate("page.privacy.does_not.camera")}</li>
        <li>{translate("page.privacy.does_not.microphone")}</li>
        <li>{translate("page.privacy.does_not.freetext")}</li>
        <li>{translate("page.privacy.does_not.uploads")}</li>
        <li>{translate("page.privacy.does_not.ads")}</li>
        <li>{translate("page.privacy.does_not.analytics")}</li>
        <li>{translate("page.privacy.does_not.ai")}</li>
        <li>{translate("page.privacy.does_not.auto_report")}</li>
      </ul>

      <h2>{translate("page.privacy.answers.heading")}</h2>
      <p>{translate("page.privacy.answers.p1")}</p>
      <p>{translate("page.privacy.answers.p2")}</p>
      <p>{translate("page.privacy.answers.p3")}</p>

      <h2>{translate("page.privacy.qr.heading")}</h2>
      <p>{translate("page.privacy.qr.p1")}</p>
      <p>{translate("page.privacy.qr.p2")}</p>

      <h2>{translate("page.privacy.leave.heading")}</h2>
      <p>{translate("page.privacy.leave.p1")}</p>
      <p>{translate("page.privacy.leave.p2")}</p>
      <p>{translate("page.privacy.leave.cannot_heading")}</p>
      <ul>
        <li>{translate("page.privacy.leave.cannot.history")}</li>
        <li>{translate("page.privacy.leave.cannot.tabs")}</li>
        <li>{translate("page.privacy.leave.cannot.dns")}</li>
        <li>{translate("page.privacy.leave.cannot.device")}</li>
        <li>{translate("page.privacy.leave.cannot.network")}</li>
        <li>{translate("page.privacy.leave.cannot.platform")}</li>
        <li>{translate("page.privacy.leave.cannot.screenshots")}</li>
        <li>{translate("page.privacy.leave.cannot.os")}</li>
      </ul>

      <h2>{translate("page.privacy.technical.heading")}</h2>
      <p>{translate("page.privacy.technical.p1")}</p>
      <p>{translate("page.privacy.technical.p2")}</p>
      <p>{translate("page.privacy.referrer.p1")}</p>
      <p>{translate("page.privacy.storage.p1")}</p>

      <h2>{translate("page.privacy.external.heading")}</h2>
      <p>{translate("page.privacy.external.p1")}</p>

      <h2>{translate("page.privacy.emergency.heading")}</h2>
      <p>{translate("page.privacy.emergency.p1")}</p>

      <h2>{translate("page.privacy.ai.heading")}</h2>
      <p>{translate("page.privacy.ai.p1")}</p>

      <h2>{translate("page.privacy.prototype.heading")}</h2>
      <p>{translate("page.privacy.prototype.p1")}</p>
    </section>
  );
}
